import { REGISTER_STRIPE_CARD_SUCCESS, SEND_ORDER_SUCCESS } from 'new-constants/api.constants';
import { PROFILE_STRIPE_SUCCES } from 'new-constants/payment.constants';
import { PaymentState } from './payment.reducer.types';
import {
	CHECK_ADYEN_PAYMENT_SUCCESS,
	CHECK_PAYMENT_STATUS_SUCCESS,
	INIT_ADYEN_PAYMENT_SUCCESS,
	SUBMIT_GOOGLE_PAY_SUCCESS,
	SUBMIT_SWISH_PAY_SUCCESS
} from "../constants/api.constants";
import { START } from "../constants/app-state.constants";
import { PaymentStatuses } from "../constants/common.constants";
import {
	CANCEL_ADYEN_CARD_REGISTRATION_POPUP,
	PROFILE_ADYEN_CARD_REGISTRATION_POPUP
} from '../constants/popup.constants';
import { ADYEN_SUCCESS } from '../constants/payment.constants';

const initialState: PaymentState = {
	orderId: null,
	stripeKey: null,
	stripeClientSecret: null,
	redirectUrl: null,
	mobilePayRedirectAction: null,
	adyenRedirectResult: null,
	adyenHandleAction: null,
    adyenRedirectResultSecret: null,
};

export const paymentReducer = (previousState = initialState, action): PaymentState => {
	switch (action.type) {
		case SEND_ORDER_SUCCESS:
			return {
				...previousState,
				orderId: action.payload.data.order.orderId,
				stripeKey: action.payload.data.stripeKey,
				stripeClientSecret: action.payload.data.stripeClientSecret,
				redirectUrl: action.payload.data.redirectUrl,
				adyenClientKey: action.payload.data.adyenClientKey,
				adyenPaymentMethodsResponse: action.payload.data.adyenPaymentMethodsResponse,
                orderAmount: action.payload.data.order.amount,
                orderCurrency: action.payload.data.order.currency,
                adyenCountryCode: action.payload.data.adyenCountryCode
			};
			break;
		case REGISTER_STRIPE_CARD_SUCCESS:
			return {
				...previousState,
				orderId: action.payload.orderId,
				stripeKey: action.payload.stripeKey,
				stripeClientSecret: action.payload.stripeClientSecret,
				redirectUrl: null,
			};
			break;

		case PROFILE_ADYEN_CARD_REGISTRATION_POPUP:
			return {
				...previousState,
				adyenClientKey: action.payload.adyenClientKey,
				adyenPaymentMethodsResponse: action.payload.adyenPaymentMethodsResponse,
				orderId: action.payload.orderId,
				redirectUrl: null,
			};
			break;

		case ADYEN_SUCCESS:
			if (!action.payload.action) {
				return {
					...previousState,
				}
			}
			return {
				...previousState,
				adyenHandleAction: action.payload.action,
			};
			break;

			case SUBMIT_GOOGLE_PAY_SUCCESS:
				if (!action.payload.action) {
					return {
						...previousState,
					}
				}
				return {
					...previousState,
					adyenHandleAction: action.payload.action,
				};
				break;

		case SUBMIT_SWISH_PAY_SUCCESS:
			if (!action.payload.action) {
				return {
					...previousState,
				}
			}
			return {
				...previousState,
				adyenHandleAction: action.payload.action,
			};
			break;

		case PROFILE_STRIPE_SUCCES:
			return {
				...previousState,
				orderId: null,
				stripeKey: null,
				stripeClientSecret: null,
				redirectUrl: null,
			};
			break;


		case CANCEL_ADYEN_CARD_REGISTRATION_POPUP:
			return {
				...previousState,
			};
			break;

		case INIT_ADYEN_PAYMENT_SUCCESS:
			return {
				...previousState,
				mobilePayRedirectAction: action.payload.data.action
			}
			break;

		case START: {
			return {
				...previousState,
				adyenRedirectResult: action.returnFromAdyen ? action.returnFromAdyen.redirectResult : previousState.adyenRedirectResult,
                adyenRedirectResultSecret: action.returnFromAdyen?.secret || null,
			}
		}
			break;

		case CHECK_PAYMENT_STATUS_SUCCESS:
			if (!(action.payload.isAdyenOrder && (action.payload.data.status === PaymentStatuses.complete || action.payload.data.status === PaymentStatuses.cancelled))) {
				return previousState;
			}

			return initialState;
			break;

		case CHECK_ADYEN_PAYMENT_SUCCESS:
			if (action.payload.data.resultCode !== PaymentStatuses.authorised) {
				return previousState;
			}

			return initialState;
			break;

		default:
			return previousState;
	}
};
